import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FolderIcon, PlusIcon, TrashIcon } from '../../components/icons';
import Spinner from '../../components/spinner';
import Loader from '../../components/loader';
import './styles.css';
import useDelete from './useDelete';
import Translate from '../../utils/Translate';
import useProjectStore from '../../hooks/store/useProjectStore';
import useAddProjectStore from '../../hooks/store/useAddProjectStore';

export default function Projects({ user, onCloseModal }) {
  const history = useHistory();
  const [uidSelected, setUidSelected] = useState('');
  const [uidUpdate, setUidUpdate] = useState('');

  const {
    onOpenDialog, onChangeStatus, isUpdating, creating,
  } = useAddProjectStore();

  const {
    projects, loading, getListProjects,
  } = useProjectStore(user.uid);

  const { onDeleteProject, copy, loading: submiting } = useDelete();

  useEffect(() => {
    getListProjects();
  }, []);

  const handleRedirect = ({ name, uid }) => {
    history.push({
      pathname: `/ai/project/chat/${uid}`,
      search: `?project=${name}`,
    });
    onCloseModal();
  };

  const handleDeleteProject = (uid) => {
    setUidSelected(uid);
    onDeleteProject({ uid, callback: getListProjects });
  };

  const handleUpdateProject = (uid) => {
    setUidUpdate(uid);
    onChangeStatus({ uid, callback: getListProjects });
  };

  const myProjects = projects.filter(project => project.status === 1);
  const recentDeleted = projects.filter(project => project.status === 0);

  const sortedRecentDeleted = recentDeleted.sort((a, b) => {
    const aDate = new Date(a.updated_at).getTime();
    const bDate = new Date(b.updated_at).getTime();
    return aDate - bDate;
  }).slice(-5);

  return (
    <Fragment>
      {loading
        ? <Loader />
        : (
          <div className="support-container">
            <MyProjects
              copy={copy}
              projects={myProjects}
              submiting={submiting}
              uidSelected={uidSelected}
              onRedirect={handleRedirect}
              onDeleteProject={handleDeleteProject}
            />
            {recentDeleted.length > 0 && (
              <RecentDeleted
                uidUpdate={uidUpdate}
                isUpdating={isUpdating}
                projects={sortedRecentDeleted}
                onChangeStatus={handleUpdateProject}
              />
            )}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                type="submit"
                disabled={creating}
                onClick={onOpenDialog}
                className="generate-ideas-button"
                style={{ textAlign: 'center' }}
              >
                {creating
                  ? <Spinner style={{ margin: '0 auto', borderLeftColor: '#000' }} />
                  : Translate.get('newProject', 'New Project')
                }
              </button>
            </div>
          </div>
        )
      }
    </Fragment>
  );
}


function MyProjects({
  projects = [], onRedirect, onDeleteProject, submiting, uidSelected,
}) {
  return (
    <div className="mb-4">
      <h3 className="support-title">{Translate.get('yourProjects', 'Your Projects')}</h3>
      {projects.map(project => (
        <div key={project.id} className="support-projects mb-2">
          <div
            role="button"
            className="support-project-title"
            onClick={() => onRedirect({ uid: project.uid, name: project.description })}
          >
            <FolderIcon />
            <h4>{project.description}</h4>
          </div>
          <div className="support-actions">
            {/* <CopyIcon onClick={() => copy('text')} /> */}
            {submiting && project.uid === uidSelected
              ? <Spinner />
              : <TrashIcon onClick={() => onDeleteProject(project.uid)} />
            }
          </div>
        </div>
      ))}
    </div>
  );
}

function RecentDeleted({
  projects = [], onChangeStatus, isUpdating, uidUpdate,
}) {
  return (
    <div>
      <h3 className="support-title">{Translate.get('recentDeleted', 'Recently deleted')}</h3>
      {projects.map(project => (
        <div key={project.id} className="support-projects mb-2">
          <div
            role="button"
            className="support-project-title"
          >
            <FolderIcon />
            <h4>{project.description}</h4>
          </div>
          {isUpdating && project.uid === uidUpdate
            ? <Spinner />
            : <PlusIcon onClick={() => onChangeStatus(project.uid)} />
          }
        </div>
      ))}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/projects/index.js